import type { FunctionComponent } from 'react';

import {
  ConfigWrapper,
  DesktopLayoutBoxed,
} from '@kanda-libs/ks-design-library';

import Copyright from 'components/Copyright';
import useHelpModal from 'components/HelpModal/useHelpModal';
import { ReduxJobSidebar } from 'components/JobSidebar';

import { JobLayoutProps } from '..';

const Desktop: FunctionComponent<JobLayoutProps> = function ({
  header,
  children,
  showSidebar = true,
}) {
  const { showHelpModal } = useHelpModal();
  return (
    <ConfigWrapper sidebar={showSidebar ? ReduxJobSidebar : undefined}>
      <DesktopLayoutBoxed
        help={showHelpModal}
        backgroundLines
        sidebar
        layoutFooter={<Copyright />}
      >
        <div className="flex flex-col w-full h-full px-4 py-16">
          <div className="flex flex-col w-full mx-auto text-left max-w-128">
            {header}
            {children}
          </div>
        </div>
      </DesktopLayoutBoxed>
    </ConfigWrapper>
  );
};

export default Desktop;
